import xss from 'xss';

export const sanitizeSeo = (seoJson) =>
    xss(JSON.stringify(seoJson), {
        whiteList: [],
        stripIgnoreTag: true,
        stripIgnoreTagBody: ['a', 'script'],
    });
